import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { notifyRouteChange } from "./apollo-route-abort";
import { trackYandexHit } from "./analytics";
import { bugsnagClient } from "./bugsnag";

export const RouteChangeNotifier = (): null => {
  const location = useLocation();
  const isFirstRun = useRef(true);

  useEffect(() => {
    const fullPath = location.pathname + location.search + location.hash;

    notifyRouteChange(fullPath);
    // GA/GTM counts SPA page_view itself via the History Change trigger.
    // Yandex.Metrika needs an explicit hit on each route change — but NOT for
    // the first page: ym('init') already counts the entry page, so firing a hit
    // here on mount would double-count it.
    if (isFirstRun.current) {
      isFirstRun.current = false;
    } else {
      trackYandexHit(window.location.href);
    }
    bugsnagClient.leaveBreadcrumb(
      "Route changed",
      { path: fullPath },
      "navigation",
    );

    console.log("Route changed to:", fullPath);
  }, [location.pathname, location.search, location.hash]);

  return null; // This component renders nothing
};

export default RouteChangeNotifier;
